import React, {PureComponent} from 'react';
import './styles/Sidebar.css';
import {NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import logo from './images/logo_amcemig.png';
import cerebro from './images/cerebro.jpg';
import { Collapse } from 'react-bootstrap';
import avatar from '../../../../images/face-0.jpg';
import {personFullName} from '../../../../services/Api'


export default class Sidebar extends PureComponent{

    static contextTypes = {api: PropTypes.object};

    constructor(props){
        super(props);
        this.state={}
        this.onLogOut = this.onLogOut.bind(this);
    }

    // verifies if routeName is the one active (in browser input)
    isActiveRoute(routeName) {
        const regex = new RegExp(routeName+"($|/)");
        return this.props.location.pathname.match( regex )?' active':'';
    }

    onLogOut = ()=>{
        this.context.api.logOut();
    };

    openMenu = ( e )=>{
        e.preventDefault();
        e.stopPropagation();
        const st = e.currentTarget.dataset.state;
        this.setState( { [st]:!this.state[st] } );
    };

    render(){

        let userImage;
        let username;

        if( this.props.user && this.props.user.person ) {
            if( this.props.user.person.photo)
                userImage = this.context.api.appFiles.getUrl( this.props.user.person.photo.id );
            else
                userImage = avatar;

            username = personFullName(this.props.user.person);
        }
        else{
            userImage = cerebro;
            username = this.props.user? this.props.user.username:'Cargando...';
        }

        return(
            <div className="sidebar" data-background-color="white" data-active-color="danger">

                <div className="logo">
                    {/*<a href="/" className="simple-text logo-mini visible-xs visible-sm">*/}
                        {/*AM*/}
                    {/*</a>*/}

                    <a href="/" className="simple-text logo-normal">
                        <img src={logo} alt='AMCEMIG' />
                    </a>
                </div>
                <div className="sidebar-wrapper">
                    <div className="user">
                        <div className="photo">
                            <img src={ userImage } alt="Avatar"/>
                        </div>
                        <div className="info">
                            <a data-toggle="collapse" data-target="#collapseExample" className="collapsed">
	                        <span>
                                {username}
		                        <b className="caret" />
							</span>
                            </a>
                            <div className="clearfix" />

                            <div className="collapse" id="collapseExample">
                                <ul className="nav">
                                    {/*
                                    <li>
                                        <NavLink to='/profile' >
                                            <span className="sidebar-mini">Mp</span>
                                            <span className="sidebar-normal">Mi Perfil</span>
                                        </NavLink>
                                    </li>
                                    */}

                                    <li>
                                        <a onClick={this.onLogOut}>
                                            <span className="sidebar-mini">Cs</span>
                                            <span className="sidebar-normal">Cerrar sesión</span>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <ul className="nav">

                        {this.props.routes.map((route,key)=> {

                            if(route.hidden || route.redirect ) return null;

                            if(route.collapse){
                                return(
                                    <li key={key}>
                                        <a href='/' data-state={route.state} onClick={this.openMenu }>
                                            <i className={route.icon} /> <p>{route.name}</p>
                                        </a>
                                        <Collapse in={this.state[route.state]}>
                                            <ul className="nav">
                                                {
                                                    route.views.map((prop,key) => {
                                                        return (
                                                            <li key={key}  onClick={()=>document.getElementsByTagName("html")[0].classList.remove("nav-open")}>
                                                                <NavLink to={prop.path} className="nav-link" activeClassName="active">
                                                                    <b><span className="sdbMini">     {prop.mini}      </span></b>
                                                                    <span className="sdbNormal">{prop.name}</span>
                                                                </NavLink>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        </Collapse>
                                    </li>
                                )
                            }

                            return(
                                <li className={this.isActiveRoute(route.path)} onClick={()=>document.getElementsByTagName("html")[0].classList.remove("nav-open")} key={route.path}>
                                    <NavLink to={route.path}>
                                        <i className={route.icon}/>
                                        <p>{route.name}</p>
                                    </NavLink>
                                </li>
                            )
                        })}

                        {/*<li>
                            <a data-toggle="collapse" href="#dashboardOverview">
                                <i className="ti-panel" />
                                <p>Collapse
                                    <b className="caret" />
                                </p>
                            </a>
                            <div className="collapse" id="dashboardOverview">
                                <ul className="nav">
                                    <li >
                                        <a href="#panda">
                                            <i className="ti-calendar" />
                                            <span className="sidebar-normal">Collapse 1</span>
                                        </a>
                                    </li>
                                    <li>
                                        <span className="sidebar-mini">C2</span>
                                        <span className="sidebar-normal">Collapse 2</span>
                                    </li>
                                </ul>
                            </div>
                        </li>*/}

                    </ul>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/Sidebar/index.jsx